import React from 'react';
import './Hero.scss';
import { Typewriter2, HeroAnimation } from '../../components';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <div className='app__hero app__wrapper section__padding' id='home'>
      <div className='app__wrapper_info'>
        <Typewriter2/>
      </div>

      <motion.div 
        animate={{x: 0, opacity:1}}
        initial={{x: 300, opacity:0}}
        transition={{ duration: 4}}
        className='app__wrapper_img'>
        <HeroAnimation/>
      </motion.div>
    </div>
  )
}

export default Hero